import React, { Component } from "react";

export default class Select extends Component {
  constructor() {
    super();
    this.state = {};
  }

  scrollToNextStep = name => {
    if (window.innerWidth <= 425) {
      let elmnt;
      switch (name) {
        case "fuelSelected":
          elmnt = document.getElementById("fuell-scroll");
          elmnt && elmnt.scrollIntoView();
          break;
        case "gearBoxNameSelected":
          elmnt = document.getElementById("gear-scroll");
          elmnt && elmnt.scrollIntoView();
          break;
        case "engineNameSelected":
          elmnt = document.getElementById("engine-scroll");
          elmnt && elmnt.scrollIntoView();
          break;
        case "yearSelected":
          elmnt = document.getElementById("year-scroll");
          elmnt && elmnt.scrollIntoView();
          break;
        default:
          return;
      }
    }
  };

  render() {
    return this.props.selectedValue ? (
      <div className="control-container">
        <select
          onChange={e => {
            this.props.getSelectValue(e);
            this.scrollToNextStep(this.props.name);
          }}
          name={this.props.name}
          className="mm-select custom-select white"
        >
          <option value="">
            {!this.props.carInfo ? "Selecciona una opción" : this.props.carInfo}
          </option>
          {this.props.values &&
            this.props.values.map((value, i) => {
              return (
                <option
                  key={i}
                  value={value}
                  // selected={this.props.selectedValue === value}
                  defaultValue={this.props.selectedValue === value}
                >
                  {value}
                </option>
              );
            })}
        </select>
      </div>
    ) : (
      <div className="control-container">
        <select
          onChange={e => {
            this.props.getSelectValue(e);
            this.scrollToNextStep(this.props.name);
          }}
          name={this.props.name}
          className="mm-select custom-select white"
          disabled={this.props.values.length === 0}
        >
          <option value="" >
            {!this.props.carInfo ? "Seleccione una opción" : this.props.carInfo}
          </option>
          {this.props.values &&
            this.props.values.map((value, i) => {
              return (
                <option key={i} value={value}>
                  {value}
                </option>
              );
            })}
        </select>
      </div>
    );
  }
}
